/**
 * Sentinel window id RequestsController holds in `requestWindow.windowProps` when
 * a Sign request renders as an overlay INSIDE the browser-action popup instead of
 * in its own window (see `shouldSignInsidePopup` in background.ts). No real
 * browser window exists behind it, so UI code must treat it as "no separate
 * request window" — e.g. PendingActionWindowModal must not offer to focus it.
 */
export const POPUP_OVERLAY_WINDOW_ID = -1
